import { api } from '@goaltree/backend/convex/_generated/api'
import { coachNamesForVoiceChange } from '@goaltree/backend/convex/lib/coach'
import { useMutation } from 'convex/react'

// Optimistic so switches flip instantly; null clears coachStyle / notifPausedUntil.
export function useUpdatePreferences() {
  return useMutation(api.preferences.updatePreferences).withOptimisticUpdate(
    (store, { coachStyle, notifPausedUntil, ...args }) => {
      const cur = store.getQuery(api.preferences.getMyPreferences, {})
      if (!cur) return
      const moved =
        args.coachVoice !== undefined ? coachNamesForVoiceChange(cur, args.coachVoice) : null
      store.setQuery(api.preferences.getMyPreferences, {}, {
        ...cur,
        ...args,
        ...moved,
        ...(coachStyle !== undefined && { coachStyle: coachStyle ?? undefined }),
        ...(notifPausedUntil !== undefined && { notifPausedUntil: notifPausedUntil ?? undefined }),
      } as typeof cur)
    },
  )
}
